<template>
  <v-container class="grey-container">
    <v-container class="pa-5">
      <v-row>
        <v-col cols="12" md="4">
          <template v-if="imageSrc && imageSrc != ''">
            <v-img
              :src="imageSrc"
              :alt="`Image for ${title}`"
              max-width="100%"
            ></v-img>
          </template>
          <template v-else>
            <v-icon size="250" color="#DCDCDC">
              {{ iconSrc }}
            </v-icon>
          </template>
        </v-col>
        <v-col cols="12" md="8">
          <h2 class="mb-3">
            <div class="primary--text font-size-height">{{ title }}</div>
          </h2>
          <p class="mb-3">{{ description }}</p>
          <div class="alignNeat">
            <strong>{{ $t("ProgrammeMsg") }}:</strong>
            <p>{{ programme }}</p>
          </div>
          <div class="alignNeat">
            <strong>{{ $t("ProjectMsg") }} :</strong>
            <p>{{ project }}</p>
          </div>
          <div class="alignNeat">
            <strong>{{ $t("CountryMsg") }}:</strong>
            <p>{{ country }}</p>
          </div>
          <div class="alignNeat">
            <strong>{{ $t("TagsMsg") }}:</strong>
            <div class="mb-5">
              <v-chip
                v-for="(tag, index) in tags"
                :key="index"
                class="ma-1 primary"
              >
                {{ tag }}
              </v-chip>
            </div>
          </div>
          <div class="alignNeat"  v-if="abstract && abstract != ''">
            <strong>{{ $t("AbstractMsg") }}:</strong>
            <p>{{ abstract }}</p>
          </div>
          <v-row class="mt-6">
            <v-col cols="6">
              <v-btn
                color="primary"
                block
                @click="downloadItem()"
                :loading="downloadLoading"
              >
                {{ $t("downloadMsg") }} <v-icon right>mdi-download</v-icon>
              </v-btn>
            </v-col>
            <!-- <v-col cols="6">
                                <v-btn color="secondary" text block>{{ $t('ReadMsg') }}</v-btn>
                            </v-col> -->
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { downloadFile } from "@/utils/download_file";
import apiCall from "@/utils/api";

export default {
  data() {
    return {
      downloadLoading: false,
      displaySubmission: {
        code: null,
        title: null,
        description: null,
        date_created: null,
        classification: null,
        access_level: null,
        country: null,
        latitude: null,
        longitude: null,
        project: null,
        community: null,
        recent_abstract: null,
        created_at: null,
        create_user: null,
      },
    };
  },
  props: {
    title: String,
    description: String,
    imageSrc: String,
    iconSrc: String,
    tags: [],
    programme: String,
    project: String,
    country: String,
    abstract: String,
    uuid: String,
    title: String,
    type: String,
  },
  methods: {
    showSubmission(item) {
      this.highLightId = item.id;
      this.displaySubmission.code = item.bitstream_uuid;
      this.displaySubmission.title = item.title;
      this.displaySubmission.file_type = item.file_type;
      this.displaySubmission.description = item.description;
      this.displaySubmission.submission_type = item.submission_type.name;
      this.displaySubmission.date_created = item.date_created; // | moment("DD-MMM-YYYY HH:mm:ss");
      this.displaySubmission.classification = item.classification.name;
      this.displaySubmission.access_level = item.access_level.name;
      this.displaySubmission.country =
        item.country.name + " (" + item.country.iso3 + ")";
      var lat = item.latitude != null ? item.latitude : "0.0";
      var long = item.longitude != null ? item.longitude : "0.0";
      this.displaySubmission.coordinates = lat + " " + long;
      this.displaySubmission.tags = JSON.parse(item.tags);
      this.displaySubmission.recent_abstract = item.recent_abstract;

      this.displaySubmission.project = null;
      this.displaySubmission.programme = null;
      if (item.collection != null) {
        this.displaySubmission.project = item.collection.name;
        if (item.collection.community != null) {
          this.displaySubmission.programme = item.collection.community.name;
        }
      }
      this.displaySubmission.created_at = item.created_at;
      this.displaySubmission.create_user = item.create_user;
      this.changeView("show");
    },
    downloadItem() {
      console.log("Display Submission:", this.uuid);
      this.downloadLoading = true;
      apiCall(
        {
          url: "/api/submission/" + this.uuid,
          /*+ '&type=public'*/ method: "GET",
        },
        {
          responseType: "blob",
        }
      )
        .then((resp) => {
          console.log(resp instanceof Blob);
          downloadFile(resp, `${this.title}.${this.type}`);
          this.message = this.$t("itemDownloadedSuccessfullyMsg");
          this.color = "success";
          this.snackbar = true;
          this.downloadLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.message = this.$t("anErrorOccurredMsg");
          this.color = "error";
          this.snackbar = true;
          this.downloadLoading = false;
        });
    },
  },
  mounted() {},
};
</script>
<style>
.grey-container {
  background-color: #5075361f;
  padding-block: 1em;
  padding-inline: 0.4em;
  border-radius: 10px;
  margin-block: 2em;
}

.alignNeat {
  display: grid;
  grid-template-columns: 35% 75%;
  gap: 0.1em;
}
.font-size-height {
  font-size: clamp(1.4238rem, 1.0921rem + 1.6585vw, 2.6469rem);
  line-height: 1 !important;
}
@media (min-width: 45em) {
  .alignNeat {
    display: grid;
    grid-template-columns: 25% 75%;
    gap: 0.1em;
  }
}
</style>
